import { Injectable, inject } from '@angular/core';
import { SecurityValidationService } from '@fantaz/shared/data-access/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { filter, map, switchMap } from 'rxjs';
import { RecaptchaActions } from './recaptcha.actions';

@Injectable()
export class RecaptchaEffects {
  #actions = inject(Actions);
  #recaptchaV3Service = inject(ReCaptchaV3Service);
  securityValidationService = inject(SecurityValidationService);
  ignoreRoutesForRecaptcha = ['', '/'];

  onRouterNavigated$ = createEffect(() =>
    this.#actions.pipe(
      ofType(ROUTER_NAVIGATED),
      filter(
        () => !this.ignoreRoutesForRecaptcha.includes(window.location.pathname),
      ),
      map(() =>
        RecaptchaActions.eventName({
          key: prepareRouteTaAction(window.location.pathname),
        }),
      ),
    ),
  );

  track = createEffect(
    () =>
      this.#actions.pipe(
        ofType(RecaptchaActions.eventName),
        switchMap((data) => {
          return this.#recaptchaV3Service
            .execute(data.key)
            .pipe(
              switchMap((token) =>
                this.securityValidationService.reCaptchaValidationV3(token),
              ),
            );
        }),
      ),
    {
      dispatch: false,
    },
  );
}

/**
 * Prepare route ta action to send to the recaptcha service. The action can
 * only contain alphanumeric characters, slashes, and underscores.
 *
 * @link https://cloud.google.com/recaptcha-enterprise/docs/actions-website
 * @param path {string} - window.location.pathname
 * @returns {string}
 */
function prepareRouteTaAction(path: string): string {
  try {
    return path.replace(/[^a-zA-Z0-9/_]/g, '_');
  } catch (e) {}

  return 'pageLoad';
}
